import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Button } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "80%", sm: 400, xl: 500 },
  bgcolor: "background.paper",
  boxShadow: "3px 2px 20px 3px rgba(0, 0, 0, 0.3)",
  borderRadius: "10px",
  p: { xs: 2, sm: 3, xl: 4 },
};

export default function PromptModal({ open, handleClose, prompt }) {
  const handleClick = () => {
    handleClose();
  };

  let promptMssg;
  let isAnArray = false;

  if (prompt) {
    if (typeof prompt === "string") {
      promptMssg = prompt;
    } else if (Array.isArray(prompt)) {
      isAnArray = true;
    }
  }

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
      }}
    >
      <Box sx={style}>
        <Box
          sx={{
            mb: { xs: 5, sm: 10 },
            mt: { xs: 5, sm: 10 },
            fontSize: { xs: "0.875rem", xl: "1.5rem" },
            "@media (min-height: 1080px)": {
              fontSize: "2rem",
            },
            textAlign: "center",
          }}
        >
          {isAnArray
            ? prompt.map((e, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <p key={index}>{e.message}</p>
              ))
            : promptMssg}
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            sx={{
              mb: { xs: 5, xl: 10 },
              color: "white",
              py: { xs: 1, xl: 1.5 },
              px: { xs: 5, xl: 10 },
              fontSize: { xs: "0.875rem", xl: "1rem" },
              backgroundColor: "#2c2966",
              "&:hover": {
                backgroundColor: "#52f7b0",
                fontWeight: "bold",
                color: "black",
              },
            }}
            onClick={() => handleClick()}
          >
            Ok
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
